<template>
   <el-dialog
        class="roundWarnDialog"
        :title="'添加供应商'"
        :visible.sync="showAddSupplier"
        width="840px"
        :close-on-click-modal="false"
        @close="close"
        height="600px"
    >
        <el-table
            v-loading="loading"
            :data="tblist"
            border
            stripe
            ref="roundwarntable"
            class="roundwarn-tab-list"
            height="430"
            @selection-change="handleSelectionChange"
        >
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                v-for="(item, index) in columnsList"
                :key="index"
                :prop="item.prop"
                :label="item.label"
            >
                <template slot-scope="scope">
                    <span v-if="scope.column.label === '供应商编码'">{{scope.row.supplierCode}}</span>
                    <span v-if="scope.column.label === '供应商名称'">{{scope.row.supplierName}}</span>
                    <span v-if="scope.column.label === '操作状态'">{{scope.row.tenderStatusText}}</span>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-pagination
                class="text-right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageInfo.pageNo"
                :page-size="pageInfo.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="totalCount">
            </el-pagination>
            <div>
                <el-button size="mini" @click="close">取 消</el-button>
                <el-button size="mini" type="primary" :loading="btnload" @click="addfn">添 加</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { selectSupplierToQuoted, addSupplierToFirstTender } from '../../../api/tenderDetails.js';
export default {
    props: {
        showAddSupplier: {
            type: Boolean,
            default() {
                return false;
            }
        },
        tenderCode: {
            type: String,
            default() {
                return '';
            }
        },
        bidNo: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            selectList: [],
            loading: false,
            btnload: false,
            totalCount: 0,
            pageInfo: {
                pageNo: 1,
                pageSize: 10
            },
            columnsList: [
                {
                    prop: 'supplierCode',
                    label: '供应商编码',
                    width: '180'
                },
                {
                    prop: 'supplierName',
                    label: '供应商名称',
                    width: '180'
                }
            ],
            tblist: []
        };
    },
    methods: {
        close() {
            this.$emit('update:showAddSupplier', false);
        },
        handleSizeChange(val) {
            this.pageInfo.pageNo = 1;
            this.pageInfo.pageSize = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageSize = val;
            this.loadData();
        },
        handleSelectionChange(select) {
            this.selectList = select;
        },
        loadData() {
            this.loading = true;
            const params = {
                ...this.pageInfo,
                bidNo: this.bidNo,
                tenderCode: this.tenderCode
            };
            selectSupplierToQuoted(params).then(res => {
                if (res && res.code === '0') {
                    this.tblist = res.data.list;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        getSupplierCode() {
            return this.selectList.map((el) => {
                return el.supplierCode;
            });
        },
        addfn() {
            if (!this.selectList.length) {
                this.$message.warning('至少选择一个供应商！');
                return;
            }
            this.btnload = true;
            const supplierCodes = this.getSupplierCode();
            const params = {
                supplierCodes,
                bidNo: this.bidNo,
                tenderCode: this.tenderCode
            };
            addSupplierToFirstTender(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('成功添加供应商！');
                    this.$emit('update:showAddSupplier', false);
                }
            }).finally(() => {
                this.btnload = false;
            });
        }
    },
    watch: {
        showAddSupplier() {
            this.loadData();
        }
    }
};
</script>

<style>

</style>